import React from 'react'

import styles from './account-review-placeholder.module.scss'

export default function AccountReviewPlaceholder() {
    return (
        <main className={styles.page}>
            <section className={styles.card} aria-labelledby="account-review-message">
                <p id="account-review-message" data-testid="account-review-placeholder">
                    Account is in review. Please contact:{' '}
                    <a href="https://feedback.knovigator.com">feedback.knovigator.com</a> .
                </p>
            </section>
        </main>
    )
}
